// extracted by mini-css-extract-plugin
export default {"header":"styles_header__+FLuT","title":"styles_title__awbYr","text":"styles_text__11+3w"};